<template>
    <Page header="Инвойсы" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div class="w-full flex flex-column gap-3 overflow-hidden">
                <!-- <OrdersStat :stat="stat" /> -->
                <div v-if="!loading && orders" class="w-full overflow-hidden" style="max-width:100%">
                    <AdminOrderList ref="adminOrderList" 
                        :orders="orders" 
                        :users="users" 
                        :filters="lazyParams.filters"
                        :totalRecords="totalOrders" 
                        :loading="loading"
                        @filter="setFilter" 
                        @lazyParams="setParams" 
                        :defaultParams="lazyParams" />
                </div>
                <Skeleton v-else width="100%" height="30px" />
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AdminOrderList from '@/components/admin/order_list.vue'
import Page from '@/components/public/page.vue'
import OrdersStat from '@/components/admin/orders_stat.vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'

export default {
    data() {
        return {
            loading: false,
            orders: null,
            users: [],        // TODO: перенести в store
            stat: null,
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: null,
                sortOrder: null,
                sort: null,
                filters: {},
            },
            filters: {
                _id: {value: '', matchMode: 'contains'}, 
                ext_order_id: {value: '', matchMode: 'contains'},
                user_id: {value: '', matchMode: 'contains'},
                client_id: {value: '', matchMode: 'contains'},
                project_id: {value: '', matchMode: 'contains'},
                subscription_id: {value: '', matchMode: 'contains'},
                status: {value: '', matchMode: 'contains'},
                bank_code: {value: '', matchMode: 'contains'},
                created_at: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            },
            totalOrders: 0,
        }
    },
    components: {
        AdminOrderList,
        OrdersStat,
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        exportCSV() {
            if (this.$refs.adminOrderList && this.$refs.adminOrderList.exportCSV) {
                this.$refs.adminOrderList.exportCSV()
            } else {
                this.showMess('warn', 'Экспорт', 'Компонент списка недоступен')
            }
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.LoadOrders();
        },
        setParams(params) {
            this.lazyParams = params
            this.LoadOrders()
        },
        onPage(event) {
            this.lazyParams = event
        },
        async LoadOrders() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const orders = await this.connect.GetAdminOrders(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, {}).then(res=>res)
            if(orders.result) {
                this.orders = orders.data
                this.totalOrders = orders.total
            } else {
                this.orders = []
                this.totalOrders = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке заказов')
            }
            this.loading = false
        },
        async LoadUsers() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const account_data = await this.connect.GetAdminUsers().then(res=>res)
            if(account_data.result) {
                this.users = account_data.data
            } else {
                this.users = []
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке заказов')
            }
            this.loading = false
        },
        async LoadStat(){
            this.loading = true
            const statRes = await this.connect.GetAdminOrderStat().then(res=>res)
            if(statRes.result){
                this.stat = statRes.data
            } else {
                this.stat = null
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке статистики')
            }
            this.loading = false
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters

        // получим параметры из url
        const query = (this.$route.query) ? this.$route.query : {}
        if(query && query.subscription_id) this.filters.subscription_id = {value: query.subscription_id, matchMode: 'contains'}

        this.LoadOrders()
        this.LoadUsers()
    },
}
</script>